import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=304ee8ca&scoped=true"
import script from "./ServiceItem.vue?vue&type=script&lang=js"
export * from "./ServiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304ee8ca",
  null
  
)

export default component.exports